import { render, staticRenderFns } from "./ShipmentsWrapper.vue?vue&type=template&id=f9fcb408"
import script from "./ShipmentsWrapper.vue?vue&type=script&lang=js"
export * from "./ShipmentsWrapper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports